(function () {
  var toggle = document.querySelector("[data-menu-toggle]");
  var panel = document.querySelector("[data-menu-panel]");
  if (toggle && panel) {
    toggle.addEventListener("click", function () {
      var open = panel.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  document.querySelectorAll("[data-gallery]").forEach(function (root) {
    var main = root.querySelector("[data-gallery-main]");
    root.querySelectorAll("[data-gallery-thumb]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var src = btn.getAttribute("data-src");
        var line = btn.getAttribute("data-line") === "1";
        if (main && src) {
          main.src = src;
          main.classList.toggle("is-line", line);
        }
        root.querySelectorAll("[data-gallery-thumb]").forEach(function (b) {
          b.classList.toggle("is-on", b === btn);
        });
      });
    });
  });

  var disk = document.querySelector("[data-disk]");
  if (disk) {
    var inner = disk.querySelector("[data-disk-inner]");
    var angle = -18;
    var dragging = false;
    var last = 0;
    var INNER = 5.256585365853659 / 6.724;
    var pct = INNER * (410 / 480) * 100;
    if (inner) {
      inner.style.width = pct + "%";
      inner.style.height = pct + "%";
      inner.style.transform = "translate(-50%, -50%) rotate(" + angle + "deg)";
    }
    function pointerAngle(e) {
      var r = disk.getBoundingClientRect();
      var x = e.clientX - (r.left + r.width / 2);
      var y = e.clientY - (r.top + r.height / 2);
      return (Math.atan2(y, x) * 180) / Math.PI;
    }
    function apply() {
      if (inner) inner.style.transform = "translate(-50%, -50%) rotate(" + angle + "deg)";
    }
    disk.addEventListener("pointerdown", function (e) {
      dragging = true;
      last = pointerAngle(e);
      disk.setPointerCapture(e.pointerId);
    });
    disk.addEventListener("pointermove", function (e) {
      if (!dragging) return;
      var a = pointerAngle(e);
      var d = a - last;
      if (d > 180) d -= 360;
      if (d < -180) d += 360;
      last = a;
      angle += d;
      apply();
    });
    function up() { dragging = false; }
    disk.addEventListener("pointerup", up);
    disk.addEventListener("pointercancel", up);
    disk.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft" || e.key === "ArrowDown") { e.preventDefault(); angle -= 8; apply(); }
      if (e.key === "ArrowRight" || e.key === "ArrowUp") { e.preventDefault(); angle += 8; apply(); }
    });
  }
})();
